// extracted by mini-css-extract-plugin
module.exports = {"magazineWrapper":"Magazine_magazineWrapper__3_Lop","page":"Magazine_page__1QC_l","disclaimer":"Magazine_disclaimer__3xBs9","toolbar":"Magazine_toolbar__1pqxA"};